import React, { useState } from "react";
import { PostCard } from "../../Adviser/Tabs/HelperFunctions/HelperFunctions";
import { ReactComponent as DropdownIcon } from "../../../assets/icons/paraplanningDashboard/ArrowDropdown.svg";
import { money, refundableLabel } from "./FeeStructureDetails";
import { sortVersions } from "./feeStructureModel";

const fields = {
  version: "Version", date: "Date", fixedFee: "Fixed fee", refundable: "Refundable",
  tiers: "Progressive tiers", ongoingType: "Ongoing fee type", ongoingRate: "Ongoing rate",
  ongoingTiers: "Ongoing tiers", charges: "Additional charges", variations: "Fee variations", notes: "Fee notes",
};
const imported = fee => fee.source?.startsWith("client-agreement-html");
const time = value => {
  if (!value) return "-";
  const date = value.toDate ? value.toDate() : new Date(value);
  return Number.isNaN(date.getTime()) ? "-" : date.toLocaleString("en-GB", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
};
const format = (key, value) => {
  if (value === "" || value == null || (Array.isArray(value) && !value.length)) return "-";
  if (key === "fixedFee") return money(value);
  if (key === "refundable") return refundableLabel(value);
  if (key === "ongoingRate") return `${value}% p.a.`;
  if (key === "ongoingType") return value === "tiered" ? "Tiered" : "Fixed";
  if (key === "tiers" || key === "ongoingTiers") return value.map(r => `${r.rate}% · ${money(r.from)} to ${r.to === "" ? "no upper limit" : money(r.to)}`).join("; ");
  if (key === "charges") return value.map(r => `${r.name}: ${money(r.amount)}`).join("; ");
  return String(value);
};
export default function FeeStructureEditLogs({ versions }) {
  const [open, setOpen] = useState(false);
  const logs = sortVersions(versions);
  return <PostCard title="Edit Logs" right={<button type="button" className="table-row-action" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-label={open ? "Collapse history" : "Expand history"} title={open ? "Collapse history" : "Expand history"}>
    <DropdownIcon aria-hidden style={{ transform: open ? "rotate(180deg)" : "rotate(0deg)", transition: "transform 0.2s ease" }} />
  </button>}>
    {open && (logs.length ? <div className="lcEditLogsList">{logs.map(log => {
      const isImport = imported(log);
      const previous = logs.find(v => v.id === log.previousId);
      const author = isImport ? log.sourceUpdatedByName || log.sourceUpdatedBy : log.updatedByName || log.updatedBy;
      const visible = Object.keys(fields).filter(key => isImport
        ? key !== "notes" && !(key === "ongoingType" && log.category !== "financial-planning") && format(key, log[key]) !== "-"
        : JSON.stringify(log[key]) !== JSON.stringify(previous?.[key]));
      return <div key={log.id} className="lcEditLogItem">
        <div className="lcEditLogHeader"><span className="FP_Help_Text_Semibold">{author || "Unknown user"}</span><span className="FP_Help_Text muted">{time(isImport ? log.sourceUpdatedAt : log.createdAt)}</span></div>
        {isImport && <p className="FP_Help_Text muted">Source agreement · {log.version}</p>}
        <div className="lcEditLogChanges">{visible.map(key => <div key={key} className="lcEditLogChange">
          <div className="FP_Help_Text_Semibold">{fields[key]}</div>
          {isImport ? <div className="FP_Help_Text"><span className="muted">Saved value:</span> {format(key, log[key])}</div> : <>
            <div className="FP_Help_Text"><span className="muted">From:</span> {format(key, previous?.[key])}</div>
            <div className="FP_Help_Text"><span className="muted">To:</span> {format(key, log[key])}</div>
          </>}
        </div>)}</div>
      </div>;
    })}</div> : <p className="Content-Small muted">No fee edit logs found yet. New changes will appear here after saving.</p>)}
  </PostCard>;
}
